module.exports = "<section >\r\n  <form name=\"form\" #f=\"ngForm\" novalidate>\r\n    <div class=\"form-group\" align='center'>\r\n      <div  id=\"general\">\r\n        <div id=\"general-left\">\r\n          <div id=\"instruction-text\">\r\n            <textarea id=\"admission\" datatype='text' Rows='13' cols='104' readonly autofocus> {{admission}}\r\n            </textarea>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</section>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/specialAdmitted/specialAdmitted.component.html
// module id = ./src/app/specialAdmitted/specialAdmitted.component.html
// module chunks = app